// extracted by mini-css-extract-plugin
export default {"wrap":"cG-z","fullWidth":"dG-z","hideOnDesktop":"eG-z","content":"fG-z","hasOpenedNav":"gG-z","crumbsList":"hG-z","dropdownsWrap":"iG-z"};